const CARD_MOTION_OFFSETS = [
  "-4px",
  "5px",
  "-5px",
  "4px",
  "-4px",
  "5px",
  "-3px",
  "4px",
];

const CARD_MOTION_DRIFT_X = [
  "8px",
  "-7px",
  "7px",
  "-8px",
  "7px",
  "-6px",
  "8px",
  "-7px",
];

const CARD_MOTION_DRIFT_Y = [
  "-6px",
  "5px",
  "-5px",
  "6px",
  "-6px",
  "5px",
  "-4px",
  "6px",
];

const CARD_MOTION_RETURN_Y = [
  "4px",
  "-4px",
  "3px",
  "-4px",
  "4px",
  "-3px",
  "3px",
  "-4px",
];

const CARD_MOTION_ROTATIONS = [
  "-0.24deg",
  "0.2deg",
  "-0.18deg",
  "0.26deg",
  "-0.22deg",
  "0.18deg",
  "-0.24deg",
  "0.22deg",
];

const CARD_MOTION_RIPPLE_OPACITIES = [
  0.28,
  0.24,
  0.3,
  0.25,
  0.31,
  0.24,
  0.28,
  0.26,
];

const CARD_MOTION_SCALES = [
  "1.02",
  "0.98",
  "1",
  "0.99",
  "1.03",
  "0.98",
  "1",
  "1.01",
];

const CARD_MOTION_RIPPLE_SIZES = [244, 224, 254, 232, 262, 226, 246, 238];

function getIndexedValue(values, index) {
  return values[index % values.length];
}

export function getCardMotionStyle(index = 0) {
  const rippleSize = getIndexedValue(CARD_MOTION_RIPPLE_SIZES, index);
  const rippleDesktopSize = Math.round(rippleSize * 1.18);

  return {
    "--card-motion-delay": `${index * -1.15}s`,
    "--card-motion-offset-x": getIndexedValue(CARD_MOTION_OFFSETS, index),
    "--card-motion-drift-x": getIndexedValue(CARD_MOTION_DRIFT_X, index),
    "--card-motion-drift-y": getIndexedValue(CARD_MOTION_DRIFT_Y, index),
    "--card-motion-return-y": getIndexedValue(CARD_MOTION_RETURN_Y, index),
    "--card-motion-rotate": getIndexedValue(CARD_MOTION_ROTATIONS, index),
    "--card-motion-scale": getIndexedValue(CARD_MOTION_SCALES, index),
    "--card-motion-drift-duration": `${10.5 + (index % 5) * 1.1}s`,
    "--card-motion-ripple-duration": `${8.8 + (index % 4) * 0.65}s`,
    "--card-motion-ripple-delay": `${index * -0.72}s`,
    "--card-motion-ripple-mobile": `${rippleSize}px`,
    "--card-motion-ripple-mobile-mid": `${Math.round(rippleSize * 0.82)}px`,
    "--card-motion-ripple-mobile-inner": `${Math.round(rippleSize * 0.62)}px`,
    "--card-motion-ripple-mobile-core": `${Math.round(rippleSize * 0.42)}px`,
    "--card-motion-ripple-desktop": `${rippleDesktopSize}px`,
    "--card-motion-ripple-desktop-mid": `${Math.round(
      rippleDesktopSize * 0.82
    )}px`,
    "--card-motion-ripple-desktop-inner": `${Math.round(
      rippleDesktopSize * 0.62
    )}px`,
    "--card-motion-ripple-desktop-core": `${Math.round(
      rippleDesktopSize * 0.42
    )}px`,
  };
}

export function CardMotionStyles() {
  return (
    <style>{`
      @keyframes card-motion-ripple-out {
        0% {
          opacity: 0;
          transform: translate3d(-50%, -50%, 0) scale(0.64);
        }

        18% {
          opacity: var(--card-motion-ripple-opacity);
        }

        68% {
          opacity: var(--card-motion-ripple-fade-opacity);
        }

        100% {
          opacity: 0;
          transform: translate3d(-50%, -50%, 0) scale(1.22);
        }
      }

      @keyframes card-motion-drift {
        0%,
        100% {
          transform: translate3d(
            var(--card-motion-offset-x),
            4px,
            0
          ) rotate(var(--card-motion-rotate)) scale(var(--card-motion-scale));
        }

        28% {
          transform: translate3d(
            calc(var(--card-motion-offset-x) + var(--card-motion-drift-x)),
            var(--card-motion-drift-y),
            0
          ) rotate(calc(var(--card-motion-rotate) + 0.28deg)) scale(var(--card-motion-scale));
        }

        58% {
          transform: translate3d(
            var(--card-motion-offset-x),
            var(--card-motion-return-y),
            0
          ) rotate(calc(var(--card-motion-rotate) - 0.22deg)) scale(var(--card-motion-scale));
        }

        82% {
          transform: translate3d(
            var(--card-motion-offset-x),
            0,
            0
          ) rotate(calc(var(--card-motion-rotate) + 0.14deg)) scale(var(--card-motion-scale));
        }
      }

      .card-motion-drift {
        animation: card-motion-drift var(--card-motion-drift-duration) ease-in-out infinite;
        animation-delay: var(--card-motion-delay);
        transform: translate3d(var(--card-motion-offset-x), 4px, 0)
          rotate(var(--card-motion-rotate)) scale(var(--card-motion-scale));
        transform-origin: 50% 50%;
        will-change: transform;
      }

      .card-motion-ripple {
        left: 50%;
        top: 50%;
        aspect-ratio: 1 / 1;
        animation: card-motion-ripple-out var(--card-motion-ripple-duration) ease-out infinite;
        animation-delay: var(--card-motion-ripple-delay);
        opacity: 0;
        transform: translate3d(-50%, -50%, 0) scale(0.64);
        will-change: transform, opacity;
      }

      .card-motion-ripple-mid {
        animation-delay: calc(var(--card-motion-ripple-delay) + 1.35s);
      }

      .card-motion-ripple-inner {
        animation-delay: calc(var(--card-motion-ripple-delay) + 2.7s);
      }

      .card-motion-ripple-core {
        animation-delay: calc(var(--card-motion-ripple-delay) + 4.05s);
      }

      .group:hover .card-motion-ripple,
      .group:focus-visible .card-motion-ripple {
        filter: brightness(1.18);
      }

      @media (prefers-reduced-motion: reduce) {
        .card-motion-ripple {
          animation: none !important;
          opacity: var(--card-motion-ripple-fade-opacity);
          transform: translate3d(-50%, -50%, 0) scale(1);
        }

        .card-motion-drift {
          animation: none !important;
          transform: translate3d(var(--card-motion-offset-x), 0, 0)
            rotate(var(--card-motion-rotate)) scale(var(--card-motion-scale));
        }
      }
    `}</style>
  );
}

function CardRippleLayers({ opacity }) {
  return (
    <>
      <span
        className="card-motion-ripple pointer-events-none absolute z-0 w-[var(--card-motion-ripple-mobile)] rounded-full bg-[radial-gradient(circle,rgba(255,246,168,0.24)_0%,rgba(244,217,78,0.12)_30%,rgba(106,174,37,0.055)_56%,transparent_76%)] blur-xl sm:w-[var(--card-motion-ripple-desktop)]"
        style={{
          "--card-motion-ripple-opacity": opacity * 0.72,
          "--card-motion-ripple-fade-opacity": opacity * 0.18,
        }}
      />
      <span
        className="card-motion-ripple pointer-events-none absolute z-[1] w-[var(--card-motion-ripple-mobile)] rounded-full border border-[#fff6a8]/42 shadow-[0_0_16px_rgba(244,217,78,0.18),inset_0_0_18px_rgba(244,217,78,0.08)] sm:w-[var(--card-motion-ripple-desktop)]"
        style={{
          "--card-motion-ripple-opacity": opacity,
          "--card-motion-ripple-fade-opacity": opacity * 0.24,
        }}
      />
      <span
        className="card-motion-ripple card-motion-ripple-mid pointer-events-none absolute z-[1] w-[var(--card-motion-ripple-mobile-mid)] rounded-full border border-[#f4d94e]/34 sm:w-[var(--card-motion-ripple-desktop-mid)]"
        style={{
          "--card-motion-ripple-opacity": opacity * 0.82,
          "--card-motion-ripple-fade-opacity": opacity * 0.2,
        }}
      />
      <span
        className="card-motion-ripple card-motion-ripple-inner pointer-events-none absolute z-[1] w-[var(--card-motion-ripple-mobile-inner)] rounded-full border border-white/24 sm:w-[var(--card-motion-ripple-desktop-inner)]"
        style={{
          "--card-motion-ripple-opacity": opacity * 0.68,
          "--card-motion-ripple-fade-opacity": opacity * 0.16,
        }}
      />
      <span
        className="card-motion-ripple card-motion-ripple-core pointer-events-none absolute z-[1] w-[var(--card-motion-ripple-mobile-core)] rounded-full border border-[#fff6a8]/28 bg-white/[0.025] sm:w-[var(--card-motion-ripple-desktop-core)]"
        style={{
          "--card-motion-ripple-opacity": opacity * 0.56,
          "--card-motion-ripple-fade-opacity": opacity * 0.13,
        }}
      />
    </>
  );
}

function CardMotionFrame({
  children,
  className = "",
  index = 0,
  includeRipples = true,
  style,
}) {
  const opacity = getIndexedValue(CARD_MOTION_RIPPLE_OPACITIES, index);

  return (
    <div
      className={`card-motion-drift relative ${className}`}
      style={{
        ...getCardMotionStyle(index),
        ...(style || {}),
      }}
    >
      {includeRipples ? <CardRippleLayers opacity={opacity} /> : null}
      <div className="relative z-10 h-full w-full">{children}</div>
    </div>
  );
}

export default CardMotionFrame;
